<template>
  <div class="dashboard-container">
    <h1>北京冰球协会管理系统</h1>
    <div class="dashboard-text">姓名: {{ name }}</div>
    <!--<div class="dashboard-text">roles:<span v-for="role in roles" :key="role">{{ role }}, </span></div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import router from '@/router'
import store from '@/store'
import { setRoles, getRoles } from '@/utils/auth' // getToken from cookie

export default {
  name: 'Dashboard',
  computed: {
    ...mapGetters([
      'name',
      'roles'
    ])
  },
  methods: {
    handleRolesChange() {

    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
    text-align: center;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
